// extracted by mini-css-extract-plugin
module.exports = {"root":"mobileMenuHandler_root__NV69M","menuIcon":"mobileMenuHandler_menuIcon__rDNEh"};